// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__pDKSB","desktop":"styles_desktop__L0bDi"};